$(document).ready(function () {
  waitForElementToExist('.newsletter').then(function () {
    var newsLetter = new NewsLetter();
    var newsLetterBox = $('.modal-newsletter');
    var newsLetterMessage = $('.newsletter__content--message');
    var newsForm = $('.newsletter__form');

    $('#js-form-news').off('submit.newsletter').on('submit.newsletter', function (event) {
      event.preventDefault();

      if (!this.checkValidity()) {
        this.reportValidity();
        return;
      }

      $(this).addClass('form-news-sending');
      newsLetter.addEmail({
        email: $(this).find('input[name="email"]').val()
      });
    });

    $('#js-form-news-2').off('submit.newsletter').on('submit.newsletter', function (event) {
      event.preventDefault();
      $(this).addClass('form-news-sending');
      newsLetter.addEmail({
        email: $(this).find('#email_2').val()
      });
    });

    function clearMessage(state) {
      setTimeout(function () {
        newsLetterBox.removeClass('is-active');
        newsLetterMessage.removeClass(state);
        newsForm.removeClass('form-news-sending');
      }, 4000);
    }

    $(newsLetter).bind('onSuccessAddEmailNewsLetter', function (event) {
      event.preventDefault();
      newsLetterBox.addClass('is-active');
      newsLetterMessage.html('Obrigado por participar. Confira seu e-mail!').addClass('success');
      $('#js-form-news')[0].reset();
      clearMessage('success');
    }).bind('onFailAddEmailNewsLetter500', function (event, data) {
      event.preventDefault();
      newsLetterBox.addClass('is-active');
      newsLetterMessage.html(data.email && data.email[0] ? data.email[0] : 'Este e-mail já está cadastrado.').addClass('error');
      clearMessage('error');
    }).bind('onFailAddEmailNewsLetter', function (event) {
      event.preventDefault();
      newsLetterBox.addClass('is-active');
      newsLetterMessage.html('Não foi possível cadastrar o e-mail. Tente novamente.').addClass('error');
      clearMessage('error');
    });
  });
});
